import React, { Component } from 'react';
import '../App.css';
import CalendarAPI from '../Codes/CalendarAPI';
import SigninToCalendar from './SigninToCalendar';
import InputEvent from './InputEvent';
import FinishedScreen from './FinishedScreen';

class Home extends Component {
    constructor(props){
        super(props);
        
        this.state={
            signedin:undefined,
            ifFinished: false
            
        }
        this.getButtonForSignIn = this.getButtonForSignIn.bind(this);
    }

    componentDidMount(){
        //this.getGregorianDate(this.state.day, this.state.month, this.state.year);
        CalendarAPI.loadApi(this.updateSignedInState.bind(this));
    }

    updateSignedInState(flag){
        this.setState({signedin: flag});
    }

    updateFinished(flag){
        this.setState({ifFinished: flag});
    }

    getButtonForSignIn(){
        if(this.state.signedin===undefined){
            return <p>מחכה ללוח שנה</p>;
        }
        if(this.state.signedin===false){
            return <button className="btn btn-outline-dark" onClick={CalendarAPI.signIn}>התחבר ללוח שנה</button>;
        }
        if(this.state.signedin===true){
            return <button className="btn btn-outline-dark" onClick={CalendarAPI.signOut}>צא מלוח שנה</button>;
        }
    }

    render() {
        if(this.state.ifFinished===true)
            return <FinishedScreen updateFinished={this.updateFinished.bind(this)}/>;
        if(this.state.signedin===true)
            return <InputEvent updateFinished={this.updateFinished.bind(this)}/>;
        if(this.state.signedin===false)
            return <SigninToCalendar/>;
        return <p>waiting</p>;
    }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js